import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useQuery} from "../../../common/hooks";
import {Routes} from "../../../common/Routes";
import {inProgress, isNullOrUndefined} from "../../../common/utils";
import {sendUserGroupEvent, UserGroupAction} from "../../../components/matomoClient";
import {useGetUserGroupTypeId} from "../hooks/GetUserGroupTypeId";
import {useVerifyUserGroupType} from "../hooks/VerifyUserGroupType";
import {UserGroupActions} from "../model";
import {ListUserGroupTabNameQueryParam, listUserGroupTabTypes} from "./model";

export const ListUserGroupsController = (userGroupTypeUniqueName) => {
  const dispatch = useDispatch();
  let query = useQuery();

  const [queryTabName, setQueryTabName] = useState(query.get(ListUserGroupTabNameQueryParam));

  const userGroupTypeId = useGetUserGroupTypeId(userGroupTypeUniqueName);
  useVerifyUserGroupType(userGroupTypeUniqueName);

  const userGroupTypeProgress = useSelector((rootState) => rootState.userGroup.types.progress);
  const userGroupListProgress = useSelector(
    (rootState) => rootState.userGroup.userGroupList[userGroupTypeId]?.progress
  );

  const isBusinessTeam = userGroupTypeUniqueName === "business-team";

  const userGroupTypeError = useSelector((rootState) => rootState.userGroup.types.error);
  const userGroupListError = useSelector(
    (rootState) => rootState.userGroup.userGroupList[userGroupTypeId]?.error
  );

  const titleName = useSelector(
    (rootState) => rootState.userGroup.types.value[userGroupTypeId]?.titleName
  );
  let tabName = useSelector(
    (rootState) => rootState.userGroup.types.value[userGroupTypeId]?.tabName
  );
  const columnName = useSelector(
    (rootState) => rootState.userGroup.types.value[userGroupTypeId]?.columnName
  );
  const userGroupList = useSelector(
    (rootState) => rootState.userGroup.userGroupList[userGroupTypeId]?.value?.userGroupList
  );
  const isViewPermissionMember = useSelector(
    (rootState) => rootState.userGroup.userGroupList[userGroupTypeId]?.value?.isViewPermissionMember
  );
  let activeTab = useSelector(
    (rootState) => rootState.userGroup.userGroupListTabStates[userGroupTypeId]?.activeTab
  );

  tabName = isNullOrUndefined(tabName) ? "" : tabName;
  const loading = inProgress(userGroupTypeProgress) || inProgress(userGroupListProgress);
  const errorFetchingDetails =
    !isNullOrUndefined(userGroupTypeError) || !isNullOrUndefined(userGroupListError);
  activeTab = isNullOrUndefined(activeTab) ? listUserGroupTabTypes.AllList : activeTab;

  function removeParamsInLink() {
    window.history.replaceState({}, "", `${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}`);
  }

  if (!isNullOrUndefined(queryTabName)) {
    if (queryTabName === listUserGroupTabTypes.AllList.trim()) {
      activeTab = listUserGroupTabTypes.AllList;
    } else if (queryTabName === listUserGroupTabTypes.MyList.trim()) {
      activeTab = listUserGroupTabTypes.MyList;
    }
    removeParamsInLink();
  }

  function onTabChange(activeTab) {
    setQueryTabName(null);
    dispatch(UserGroupActions.setActiveTab({userGroupTypeId, activeTab}));
    sendUserGroupEvent(UserGroupAction.TabChange, `${activeTab}${tabName}`);
  }

  useEffect(() => {
    if (!isNullOrUndefined(userGroupTypeId)) {
      dispatch(UserGroupActions.getUserGroupsList(userGroupTypeId));
    }
  }, [userGroupTypeId]);

  return {
    titleName,
    tabName,
    columnName,
    loading,
    userGroupList,
    errorFetchingDetails,
    onTabChange,
    activeTab,
    isViewPermissionMember,
    isBusinessTeam
  };
};
